module.exports = __webpack_public_path__ + "prod/1.42.2/img/difficulty-three.a3120b7a.png";